import React, { useState, useEffect } from 'react';
import Footer from './common/Footer';
import Sidebar from './Sidebar';
import financeService from '../services/financeService';

/* ───── CATEGORY ICONS / COLORS ───── */
const catIcon = (name) => {
  const n = (name || '').toLowerCase();
  if (n.includes('canteen') || n.includes('food') || n.includes('mess')) return '🍔';
  if (n.includes('laundry'))    return '👕';
  if (n.includes('electricit')) return '⚡';
  if (n.includes('top'))        return '💳';
  return '📦';
};
const catColor = (name) => {
  const n = (name || '').toLowerCase();
  if (n.includes('canteen') || n.includes('food')) return '#FF6B6B';
  if (n.includes('laundry'))    return '#4ECDC4';
  if (n.includes('electricit')) return '#FFD93D';
  return '#95E1D3';
};

/* ───── TOP-UP MODAL ───── */
const TopupModal = ({ admissionId, admissionNumber, studentName, onClose, onSuccess }) => {
  const [amount,    setAmount]    = useState('');
  const [mode,      setMode]      = useState('UPI');
  const [reference, setReference] = useState('');
  const [saving,    setSaving]    = useState(false);
  const [error,     setError]     = useState('');

  const inp = { width: '100%', padding: '12px 15px', border: '2px solid #E8E4DF', borderRadius: 6, fontSize: 14, fontFamily: 'Work Sans, sans-serif', outline: 'none', boxSizing: 'border-box' };

  const processTopup = async () => {
    if (!amount || parseFloat(amount) <= 0) { setError('Please enter a valid top-up amount'); return; }
    setSaving(true); setError('');
    try {
      await financeService.topup(admissionId, parseFloat(amount), mode, reference || null);
      onSuccess();
    } catch (e) {
      setError(e.response?.data?.message || 'Top-up failed. Please try again.');
      setSaving(false);
    }
  };

  const presetBtnStyle = { padding: 12, border: '2px solid #E8E4DF', background: 'white', borderRadius: 6, fontWeight: 700, cursor: 'pointer', fontSize: 14, fontFamily: 'Work Sans, sans-serif' };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ background: 'white', padding: 40, borderRadius: 12, maxWidth: 500, width: '90%' }} onClick={e => e.stopPropagation()}>

        <div style={{ marginBottom: 30 }}>
          <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 28, color: '#1B3B5F', marginBottom: 10 }}>Top-up Pay Card</div>
          <div style={{ color: '#6B6B6B', fontSize: 14 }}>ID: {admissionNumber} — {studentName}</div>
        </div>

        {error && <div style={{ background: '#F8D7DA', border: '1px solid #F5C6CB', borderRadius: 6, padding: '10px 14px', marginBottom: 16, color: '#721C24', fontSize: 13 }}>{error}</div>}

        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', fontWeight: 700, fontSize: 12, textTransform: 'uppercase', letterSpacing: 1, color: '#6B6B6B', marginBottom: 8 }}>Top-up Amount (₹)</label>
          <input type="number" style={inp} placeholder="Enter amount" value={amount} onChange={e => setAmount(e.target.value)}
            onFocus={e => e.target.style.borderColor = '#1B3B5F'} onBlur={e => e.target.style.borderColor = '#E8E4DF'} />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginTop: 15 }}>
            {[5000, 10000, 15000].map(amt => (
              <button key={amt} onClick={() => setAmount(String(amt))} style={presetBtnStyle}
                onMouseEnter={e => { e.target.style.borderColor = '#D4AF37'; e.target.style.background = '#F8F6F3'; }}
                onMouseLeave={e => { e.target.style.borderColor = '#E8E4DF'; e.target.style.background = 'white'; }}>
                ₹{amt.toLocaleString('en-IN')}
              </button>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', fontWeight: 700, fontSize: 12, textTransform: 'uppercase', letterSpacing: 1, color: '#6B6B6B', marginBottom: 8 }}>Payment Mode</label>
          <select style={{ ...inp, cursor: 'pointer' }} value={mode} onChange={e => setMode(e.target.value)}>
            <option value="UPI">UPI</option>
            <option value="CARD">Card</option>
            <option value="CASH">Cash</option>
            <option value="BANK_TRANSFER">Bank Transfer</option>
          </select>
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', fontWeight: 700, fontSize: 12, textTransform: 'uppercase', letterSpacing: 1, color: '#6B6B6B', marginBottom: 8 }}>Transaction Reference (Optional)</label>
          <input type="text" style={inp} placeholder="Enter transaction ID / UPI reference" value={reference} onChange={e => setReference(e.target.value)}
            onFocus={e => e.target.style.borderColor = '#1B3B5F'} onBlur={e => e.target.style.borderColor = '#E8E4DF'} />
        </div>

        <div style={{ display: 'flex', gap: 15, marginTop: 30 }}>
          <button onClick={onClose} style={{ flex: 1, padding: 15, background: '#E8E4DF', color: '#2C2C2C', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: 1, cursor: 'pointer' }}
            onMouseEnter={e => e.target.style.background = '#C4BEB8'} onMouseLeave={e => e.target.style.background = '#E8E4DF'}>Cancel</button>
          <button onClick={processTopup} disabled={saving}
            style={{ flex: 1, padding: 15, background: '#1B3B5F', color: 'white', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: 1, cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.7 : 1 }}
            onMouseEnter={e => { if (!saving) e.target.style.background = '#0D1F2D'; }}
            onMouseLeave={e => { e.target.style.background = '#1B3B5F'; }}>
            {saving ? 'Processing…' : 'Complete Top-up'}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ───── PAY CARD DETAILS ───── */
const PayCardDetails = ({ onNavigate, onLogout, studentId }) => {
  const [detail,    setDetail]    = useState(null);
  const [loading,   setLoading]   = useState(true);
  const [error,     setError]     = useState('');
  const [showTopup, setShowTopup] = useState(false);
  const [blocking,  setBlocking]  = useState(false);

  const admissionId = studentId;

  const loadDetail = () => {
    if (!admissionId) { setError('No admission ID provided'); setLoading(false); return; }
    setLoading(true);
    financeService.getPayCardDetail(admissionId)
      .then(d => { setDetail(d); setError(''); })
      .catch(err => {
        if (err.response?.status === 404) setError('no_card');
        else setError('Could not load pay card details');
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { loadDetail(); }, [admissionId]); // eslint-disable-line

  const handleBlockToggle = async () => {
    const isBlocked = detail?.status === 'blocked';
    const msg = isBlocked
      ? 'Unblock this card? The student will be able to make transactions again.'
      : 'Block this card? The student will not be able to make any transactions until unblocked.';
    if (!window.confirm(msg)) return;
    setBlocking(true);
    try { await financeService.toggleBlock(admissionId); loadDetail(); }
    catch { alert('Failed to update card status.'); setBlocking(false); }
  };

  const cardStyle = { background: 'white', borderRadius: 12, padding: 30, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' };
  const cardHeaderStyle = { display: 'flex', alignItems: 'center', gap: 12, paddingBottom: 20, marginBottom: 25, borderBottom: '2px solid #E8E4DF' };

  if (loading) return (
    <div className="app-layout">
      <Sidebar activeItem="finance" onNavigate={onNavigate} onLogout={onLogout} />
      <main className="main-content" style={{ background: '#F8F6F3', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ fontSize: 18, color: '#6B6B6B' }}>Loading pay card details…</div>
      </main>
    </div>
  );

  if (error === 'no_card' || (!detail && !loading)) return (
    <div className="app-layout">
      <Sidebar activeItem="finance" onNavigate={onNavigate} onLogout={onLogout} />
      <main className="main-content" style={{ background: '#F8F6F3', padding: 40 }}>
        <div style={{ background: 'white', borderRadius: 12, padding: 60, textAlign: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
          <div style={{ fontSize: 64, marginBottom: 20 }}>💳</div>
          <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 28, color: '#1B3B5F', marginBottom: 15 }}>No Pay Card Yet</h2>
          <p style={{ color: '#6B6B6B', fontSize: 15, marginBottom: 30 }}>This student does not have a pay card. A card is automatically created on the first top-up.</p>
          <button onClick={() => onNavigate('finance')} style={{ padding: '12px 30px', background: '#1B3B5F', color: 'white', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: 'pointer' }}
            onMouseEnter={e => e.target.style.background = '#0D1F2D'} onMouseLeave={e => e.target.style.background = '#1B3B5F'}>
            ← Back to Finance
          </button>
        </div>
      </main>
    </div>
  );

  if (error && error !== 'no_card') return (
    <div className="app-layout">
      <Sidebar activeItem="finance" onNavigate={onNavigate} onLogout={onLogout} />
      <main className="main-content" style={{ background: '#F8F6F3', padding: 40 }}>
        <div style={{ background: '#F8D7DA', border: '1px solid #F5C6CB', borderRadius: 8, padding: '20px 25px', color: '#721C24' }}>
          ⚠️ {error}
          <button onClick={() => onNavigate('finance')} style={{ marginLeft: 20, padding: '8px 16px', background: '#1B3B5F', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>← Back</button>
        </div>
      </main>
    </div>
  );

  const isLowBalance = detail.balance < 2000;
  const isBlocked    = detail.status === 'blocked';
  const topupTxns    = (detail.transactions || []).filter(t => t.type === 'TOPUP');
  const allTxns      = detail.transactions || [];

  return (
    <div className="app-layout">
      <Sidebar activeItem="finance" onNavigate={onNavigate} onLogout={onLogout} />

      <main className="main-content" style={{ background: '#F8F6F3' }}>

        {/* TOP BAR */}
        <div style={{ background: 'white', padding: '20px 40px', borderBottom: '1px solid #E8E4DF' }}>
          <div style={{ fontSize: 13, color: '#6B6B6B', marginBottom: 10 }}>
            <span style={{ color: '#D4AF37', cursor: 'pointer' }} onClick={() => onNavigate('finance')}>Finance</span>
            {' / '}
            <span style={{ color: '#D4AF37', cursor: 'pointer' }} onClick={() => onNavigate('finance')}>Pay Card</span>
            {' / '}
            <span>Card Details</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 32, fontWeight: 400, color: '#1B3B5F', margin: 0 }}>{detail.studentName}</h1>
            <div style={{ background: 'linear-gradient(135deg, #D4AF37 0%, #C19A2E 100%)', color: '#1B3B5F', padding: '10px 25px', borderRadius: 25, fontSize: 14, fontWeight: 700, letterSpacing: 1 }}>
              Student ID: {detail.admissionNumber}
            </div>
          </div>
        </div>

        <div style={{ padding: 40, maxWidth: 1400, margin: '0 auto' }}>

          {/* ALERTS */}
          {isBlocked && (
            <div style={{ background: '#F8D7DA', border: '2px solid #DC3545', borderRadius: 8, padding: '15px 20px', marginBottom: 30, display: 'flex', alignItems: 'center', gap: 15 }}>
              <div style={{ fontSize: 24 }}>🔒</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, marginBottom: 3, color: '#721C24' }}>Card is Blocked</div>
                <div style={{ fontSize: 13, color: '#6B6B6B' }}>This student cannot make any transactions. Unblock the card to restore access.</div>
              </div>
              <button onClick={handleBlockToggle} disabled={blocking}
                style={{ padding: '10px 20px', background: '#2D5F4F', color: 'white', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 12, textTransform: 'uppercase', cursor: blocking ? 'not-allowed' : 'pointer' }}>
                {blocking ? 'Please wait…' : 'Unblock Card'}
              </button>
            </div>
          )}
          {!isBlocked && isLowBalance && (
            <div style={{ background: '#FFF3CD', border: '2px solid #F59E0B', borderRadius: 8, padding: '15px 20px', marginBottom: 30, display: 'flex', alignItems: 'center', gap: 15 }}>
              <div style={{ fontSize: 24 }}>⚠️</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, marginBottom: 3 }}>Low Balance Alert</div>
                <div style={{ fontSize: 13, color: '#6B6B6B' }}>Card balance is below ₹2,000. Please top-up to avoid service interruption.</div>
              </div>
              <button onClick={() => setShowTopup(true)}
                style={{ padding: '10px 20px', background: '#D4AF37', color: '#1B3B5F', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 12, textTransform: 'uppercase', cursor: 'pointer' }}>
                Top-up Now
              </button>
            </div>
          )}

          {/* BALANCE HERO */}
          <div style={{ background: 'linear-gradient(135deg, #1B3B5F 0%, #0D1F2D 100%)', color: 'white', borderRadius: 16, padding: 40, marginBottom: 30, boxShadow: '0 8px 30px rgba(27,59,95,0.3)', display: 'grid', gridTemplateColumns: '1fr auto', gap: 40, alignItems: 'center' }}>
            <div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                <div style={{ fontSize: 14, fontWeight: 600, opacity: 0.8, textTransform: 'uppercase', letterSpacing: 1.5 }}>Current Balance</div>
                <div style={{ fontSize: 64, fontWeight: 700, fontFamily: 'Cormorant Garamond, serif', lineHeight: 1 }}>{detail.balanceFmt}</div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 30, marginTop: 20 }}>
                  {[
                    { label: 'Total Top-up', val: detail.topupFmt },
                    { label: 'Total Spent',  val: detail.spentFmt },
                    { label: 'Transactions', val: String(detail.transactionCount || 0) },
                  ].map((s, i) => (
                    <div key={i} style={{ borderLeft: '3px solid rgba(255,255,255,0.3)', paddingLeft: 15 }}>
                      <div style={{ fontSize: 11, opacity: 0.7, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 5 }}>{s.label}</div>
                      <div style={{ fontSize: 24, fontWeight: 700, fontFamily: 'Cormorant Garamond, serif' }}>{s.val}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
              {!isBlocked && (
                <button onClick={() => setShowTopup(true)}
                  style={{ padding: '15px 30px', background: '#D4AF37', color: '#1B3B5F', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: 1, cursor: 'pointer', whiteSpace: 'nowrap' }}
                  onMouseEnter={e => { e.target.style.background = '#C19A2E'; e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 8px 20px rgba(212,175,55,0.4)'; }}
                  onMouseLeave={e => { e.target.style.background = '#D4AF37'; e.target.style.transform = 'none'; e.target.style.boxShadow = 'none'; }}>
                  💰 Top-up Card
                </button>
              )}
              <button onClick={handleBlockToggle} disabled={blocking}
                style={{ padding: '15px 30px', background: isBlocked ? 'rgba(45,95,79,0.9)' : 'transparent', color: 'white', border: '2px solid white', borderRadius: 8, fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: 1, cursor: blocking ? 'not-allowed' : 'pointer', opacity: blocking ? 0.7 : 1 }}
                onMouseEnter={e => { if (!blocking) { e.target.style.background = 'white'; e.target.style.color = '#1B3B5F'; }}}
                onMouseLeave={e => { e.target.style.background = isBlocked ? 'rgba(45,95,79,0.9)' : 'transparent'; e.target.style.color = 'white'; }}>
                {isBlocked ? '🔓 Unblock Card' : '🔒 Block Card'}
              </button>
            </div>
          </div>

          {/* TWO COLUMN: Category Spending + Top-up History */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 30, marginBottom: 30 }}>

            {/* Category-wise Spending */}
            <div style={cardStyle}>
              <div style={cardHeaderStyle}>
                <span style={{ fontSize: 24 }}>📊</span>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#1B3B5F', margin: 0 }}>Category-wise Spending</h2>
              </div>
              {!detail.categories || detail.categories.length === 0 ? (
                <div style={{ color: '#6B6B6B', fontSize: 14, textAlign: 'center', padding: '30px 0' }}>No spending recorded yet.</div>
              ) : detail.categories.map((c, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 15, marginBottom: 10, background: '#F8F6F3', borderRadius: 8, borderLeft: `4px solid ${catColor(c.category)}` }}>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 15, color: '#2C2C2C', marginBottom: 3 }}>{catIcon(c.category)} {c.category}</div>
                    <div style={{ fontSize: 12, color: '#6B6B6B' }}>{c.count} transaction{c.count !== 1 ? 's' : ''}</div>
                  </div>
                  <div style={{ fontSize: 20, fontWeight: 700, color: '#DC3545', fontFamily: 'Cormorant Garamond, serif' }}>
                    ₹{Number(c.amount).toLocaleString('en-IN')}
                  </div>
                </div>
              ))}
            </div>

            {/* Top-up History */}
            <div style={cardStyle}>
              <div style={cardHeaderStyle}>
                <span style={{ fontSize: 24 }}>💳</span>
                <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#1B3B5F', margin: 0 }}>Top-up History</h2>
              </div>
              {topupTxns.length === 0 ? (
                <div style={{ color: '#6B6B6B', fontSize: 14, textAlign: 'center', padding: '30px 0' }}>No top-ups recorded yet.</div>
              ) : topupTxns.map((t, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '15px 0', borderBottom: '1px solid #E8E4DF' }}>
                  <div>
                    <div style={{ fontSize: 13, color: '#6B6B6B', marginBottom: 3 }}>{t.dateTime}</div>
                    <div style={{ fontSize: 12, color: '#6B6B6B' }}>Mode: {t.paymentMode || 'N/A'}{t.referenceId ? ` · ${t.referenceId}` : ''}</div>
                  </div>
                  <div style={{ fontSize: 18, fontWeight: 700, color: '#2D5F4F', fontFamily: 'Cormorant Garamond, serif' }}>
                    +₹{Number(t.amount).toLocaleString('en-IN')}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RECENT TRANSACTIONS */}
          <div style={cardStyle}>
            <div style={cardHeaderStyle}>
              <span style={{ fontSize: 24 }}>📋</span>
              <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#1B3B5F', margin: 0 }}>Recent Transactions</h2>
            </div>
            {allTxns.length === 0 ? (
              <div style={{ color: '#6B6B6B', fontSize: 14, textAlign: 'center', padding: '40px 0' }}>No transactions yet.</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 20 }}>
                <thead>
                  <tr style={{ background: '#F8F6F3', borderBottom: '2px solid #E8E4DF' }}>
                    {['Date & Time', 'Type', 'Category', 'Description', 'Amount', 'Balance After'].map(h => (
                      <th key={h} style={{ padding: 12, textAlign: 'left', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, color: '#6B6B6B' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {allTxns.map((r, i) => {
                    const isTopup = r.type === 'TOPUP';
                    return (
                      <tr key={i} onMouseEnter={e => e.currentTarget.style.background = '#F8F6F3'} onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                        <td style={{ padding: '15px 12px', borderBottom: '1px solid #E8E4DF', fontSize: 14 }}>{r.dateTime}</td>
                        <td style={{ padding: '15px 12px', borderBottom: '1px solid #E8E4DF' }}>
                          <span style={{ display: 'inline-block', padding: '4px 10px', borderRadius: 12, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', background: isTopup ? '#D4EDDA' : '#F8D7DA', color: isTopup ? '#155724' : '#721C24' }}>
                            {isTopup ? 'Top-up' : 'Expense'}
                          </span>
                        </td>
                        <td style={{ padding: '15px 12px', borderBottom: '1px solid #E8E4DF', fontSize: 14 }}>{r.category}</td>
                        <td style={{ padding: '15px 12px', borderBottom: '1px solid #E8E4DF', fontSize: 14 }}>{r.description}</td>
                        <td style={{ padding: '15px 12px', borderBottom: '1px solid #E8E4DF', fontSize: 14, fontWeight: 700, color: isTopup ? '#2D5F4F' : '#DC3545' }}>
                          {isTopup ? '+' : '-'}₹{Number(r.amount).toLocaleString('en-IN')}
                        </td>
                        <td style={{ padding: '15px 12px', borderBottom: '1px solid #E8E4DF', fontSize: 14 }}>₹{Number(r.balanceAfter).toLocaleString('en-IN')}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>

        </div>

      {showTopup && (
        <TopupModal
          admissionId={admissionId}
          admissionNumber={detail.admissionNumber}
          studentName={detail.studentName}
          onClose={() => setShowTopup(false)}
          onSuccess={() => { setShowTopup(false); loadDetail(); }}
        />
      )}
      <Footer />
      </main>
    </div>
  );
};

export default PayCardDetails;